import React, { useCallback } from "react";
import {
  Lines,
  SecurityPill,
  Size,
  Variant,
} from "@bloomberg/media-ui-markets";
import { createClasses } from "@bloomberg/media-ui-core";
import { trackClickEvent } from "@foundation/nextjs-gtm";
import styles from "./wrappedTopMovers.module.css";
import { TopMover } from "~types/octagon";
import { addPageAction } from "~utils/newrelic/newrelicBrowser";
import useLink from "~hooks/useLink";

type WrappedTopMoversProps = {
  movers: TopMover[];
  currency: string;
  hasLots?: boolean;
};

export function WrappedTopMovers({
  movers,
  currency,
  hasLots,
}: WrappedTopMoversProps) {
  const sortedMovers = [...movers].sort(
    (a, b) => Math.abs(b.percentChange) - Math.abs(a.percentChange)
  );

  const link = useLink();

  const onClick = useCallback((ticker: string) => {
    trackClickEvent("Watchlist", "top_movers_pill", "click", "Watchlist");

    addPageAction("wrappedTopMoverClick", {
      ticker,
    });

    link.open(`/quote/${ticker}`, "_blank", "noopener,noreferrer");
  }, []);

  return (
    <div className={styles.topMoversBox}>
      <div className={styles.topMoversTitle}>Top Movers</div>
      <div className={styles.topMoversGrid}>
        {sortedMovers.map((mover, i) => {
          const className = createClasses([
            styles.topMoverPill,
            { [styles.showPositiveSign]: mover.value >= 0 && hasLots },
          ]);

          return (
            <SecurityPill
              key={mover.ticker}
              onClick={onClick}
              lines={Lines.two}
              percentChange={mover.percentChange}
              price={mover.value}
              size={Size.default}
              ticker={mover.ticker}
              variant={Variant.refresh2024}
              className={className}
              currency={mover.issuedCurrency}
              showCurrency={!Boolean(hasLots)}
            />
          );
        })}
      </div>
    </div>
  );
}
